import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IntubationService } from '../../intubation/services/intubation.service'
import { IOptionsResponse } from '../../../common/common.types'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setSellickManeuverOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getSellickManeuverOptions])
    const { entity } = response
    yield put(actions.setSellickManeuverOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setSellickManeuverOptions() error: ${e}`))
  }
}
export function* setSellickManeuverOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setSellickManeuverOptions)
}
